export default function TitleOnRoom({title}) {
  return (
    <h3 className="font-size22 font-semibold color222 text-left leading30">
      {title}
    </h3>
  );
}
